module.exports = __webpack_public_path__ + "img/bar3_1.7daeaea6.png";